import { type Notification } from '@air/api/types';
import { type NotificationsItemProps } from '@air/component-notifications';
import { formatActorNameInitialsOrDefault } from '@air/utilities';

import { NotificationBaseItem } from '~/components/AirNotifications/components/NotificationBaseItem';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type NotificationLibraryMemberUpdatedTypeProps = Pick<NotificationsItemProps, 'onClick'> & {
  notification: Notification<'libraryMemberUpdated_userIsMember', 'account'>;
};

export const NotificationLibraryMemberUpdatedType = ({
  notification,
  onClick,
}: NotificationLibraryMemberUpdatedTypeProps) => {
  const { currentWorkspace } = useCurrentWorkspace();

  return (
    <NotificationBaseItem
      meta={!!currentWorkspace?.name && `in ${currentWorkspace?.name}`}
      notification={notification}
      onClick={onClick}
      title={
        <>
          <b>{formatActorNameInitialsOrDefault(notification.data.actor)}</b> {notification.data.update}
          {` your request to join `}
          <b>{notification.data.library.title}</b>
        </>
      }
    />
  );
};
